enum JobCategory {
  EndUser = 'END_USER',
  Installer = 'INSTALLER',
  SiteManager = 'SITE_MANAGER',
  Other = 'UNKNOWN'
}

export default JobCategory;
